import { encryptedData, request } from "../../../services/api"
import type { AuthResponse } from "../../../services/types.ts"
import type { BaseApiResponse } from "../../../types/api.ts"
import type {
  SocialAuthData,
  TokenData,
  WhatsAppLoginData
} from "./services.types.ts"

const BASE_URL = "/auth"

const PATHS = {
  refreshToken: `${BASE_URL}/token/refresh/`,
  verifyToken: `${BASE_URL}/token/verify/`,
  socialAuth: `${BASE_URL}/google-login/`,
  whatsappLogin: (id: string) => `${BASE_URL}/whatsapp-login/?whatsapp_id=${id}`
}

export const refreshToken = ({ token }: TokenData) => {
  return request.api.post<AuthResponse, BaseApiResponse<unknown>>(
    PATHS.refreshToken,
    encryptedData({ refresh: token })
  )
}

export const verifyToken = ({ token }: TokenData) => {
  return request.api.post<unknown, BaseApiResponse<unknown>>(
    PATHS.verifyToken,
    encryptedData({ token })
  )
}

export const socialAuth = ({ token, provider }: SocialAuthData) => {
  return request.api.post<BaseApiResponse<AuthResponse>, BaseApiResponse<unknown>>(
    PATHS.socialAuth,
    encryptedData({ access_token: token })
  )
}

export const whatsappLogin = ({ whatsapp_id, ...data }: WhatsAppLoginData) => {
  return request.api.post<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.whatsappLogin(whatsapp_id),
    encryptedData(data)
  )
}
